/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1AccesscontrolPermissionsBatch202,
  PutApiV1AccesscontrolPermissionsBatch400,
  PutApiV1AccesscontrolPermissionsBatch401,
  PutApiV1AccesscontrolPermissionsBatch500,
  PutApiV1AccesscontrolPermissionsBatchMutationRequest,
  PutApiV1AccesscontrolPermissionsBatchMutationResponse,
} from "../../types/accessControlPermissionsController/PutApiV1AccesscontrolPermissionsBatch.ts";
import { batchPermissionViewModelSchema } from "../batchPermissionViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1AccesscontrolPermissionsBatch202Schema =
  z.any() as unknown as ToZod<PutApiV1AccesscontrolPermissionsBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1AccesscontrolPermissionsBatch400Schema =
  z.any() as unknown as ToZod<PutApiV1AccesscontrolPermissionsBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1AccesscontrolPermissionsBatch401Schema =
  z.any() as unknown as ToZod<PutApiV1AccesscontrolPermissionsBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1AccesscontrolPermissionsBatch500Schema =
  z.any() as unknown as ToZod<PutApiV1AccesscontrolPermissionsBatch500>;

export const putApiV1AccesscontrolPermissionsBatchMutationRequestSchema =
  z.lazy(
    () => batchPermissionViewModelSchema,
  ) as unknown as ToZod<PutApiV1AccesscontrolPermissionsBatchMutationRequest>;

export const putApiV1AccesscontrolPermissionsBatchMutationResponseSchema =
  z.lazy(
    () => putApiV1AccesscontrolPermissionsBatch202Schema,
  ) as unknown as ToZod<PutApiV1AccesscontrolPermissionsBatchMutationResponse>;
